import { render, staticRenderFns } from "./previewBasic.vue?vue&type=template&id=378bbd4e&lang=html&"
import script from "./previewBasic.vue?vue&type=script&lang=js&"
export * from "./previewBasic.vue?vue&type=script&lang=js&"
import style0 from "./previewBasic.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports